var map = {
	"./bongo-coding-pfp.png": 31685,
	"./coding-cat-mugshot-pfp.png": 40904,
	"./coding-cat-pfp.png": 48090,
	"./laptop-pfp.png": 89035,
	"./thumbs-up-pfp.png": 41890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6628;